import axiosPost from '../axiosPost';

export const cargosDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "CargoDel",
        "params": {
            "cargoId": id
        }
    };

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
};